import React from 'react';
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout';

//loadable for bcm user
import BCMUserLoad from './common/route/BCMUserLoad';

//use normal loadable for normal route
//bcmyserload is use for scorecard checking can find this at commom-route-bcmuserload

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const MainReport = Loadable({
  loader: () => import('./views/Report/MainReport'),
  loading: Loading,
});

const CustomizeReport = Loadable({
  loader: () => import('./views/Report/CustomizeReport'),
  loading: Loading,
});

const ViewReport = Loadable({
  loader: () => import('./views/Report/ViewReport'),
  loading: Loading,
});

const ReportQuery = Loadable({
  loader: () => import('./views/ReportQuery/ReportQuery'),
  loading: Loading,
});

const UserList = Loadable({
  loader: () => import('./views/UserSetup/UserManagement/UserList'),
  loading: Loading,
});

const UserInformation = Loadable({
  loader: () => import('./views/UserSetup/UserManagement/UserInformation'),
  loading: Loading,
});

const Roles = Loadable({
  loader: () => import('./views/UserSetup/SetupRole/Roles'),
  loading: Loading,
});

const View = Loadable({
  loader: () => import('./views/UserSetup/SubAdminAccess/View'),
  loading: Loading,
});

const MyTask = Loadable({
  loader: () => import('./views/MyTask'),
  loading: Loading,
});

const DomainServer = Loadable({
  loader: () => import('./views/Admin/DomainServer'),
  loading: Loading,
});

const LicenseInfo = Loadable({
  loader: () => import('./views/Admin/LicenseInfo'),
  loading: Loading,
});

const DetailAnnoucement = Loadable({
  loader: () => import('./views/Announcement/DetailAnnoucement'),
  loading: Loading,
});

const SystemLog = Loadable({
  loader: () => import('./views/Admin/SystemLog'),
  loading: Loading,
});

const SecuritySetupList = Loadable({
  loader: () => import('./views/Security/SecuritySetupList/SecuritySetupList'),
  loading: Loading,
});

const SecuritySetupInput = Loadable({
  loader: () => import('./views/Security/SecuritySetupInput/SecuritySetupInput'),
  loading: Loading,
});

const ViewSchedulerHistory = Loadable({
  loader: () => import('./views/TaskScheduler/ViewSchedulerHistory/ViewSchedulerHistory'),
  loading: Loading,
});

const ConfigureSystemSettings = Loadable({
  loader: () => import('./views/Utilities/ConfigureSystemSettings/ConfigureSystemSettings'),
  loading: Loading,
});

const CustomiseEmailTemplates = Loadable({
  loader: () => import('./views/Utilities/CustomiseEmailTemplates/CustomiseEmailTemplates'),
  loading: Loading,
});

const SMTPSettingsEmailNotification = Loadable({
  loader: () => import('./views/Utilities/SMTPSettingsEmailNotification/SMTPSettingsEmailNotification'),
  loading: Loading,
});

const EmailLog = Loadable({
  loader: () => import('./views/Utilities/EmailLog/EmailLog'),
  loading: Loading,
});

const UnsentEmailLog = Loadable({
  loader: () => import('./views/Utilities/UnsendEmailLog/UnsendEmailLog'),
  loading: Loading,
});

const Archive = Loadable({
  loader: () => import('./views/AuditHistory/Archive/Archive'),
  loading: Loading,
});

const SendEmailLog = Loadable({
  loader: () => import('./views/Utilities/SendEmailLog/SendEmailLog'),
  loading: Loading,
});

const UserActivityLog = Loadable({
  loader: () => import('./views/AuditHistory/UserActivityLog/UserActivityLog'),
  loading: Loading,
});

const LogoImport = Loadable({
  loader: () => import('./views/Utilities/LogoImport'),
  loading: Loading,
});

const LanguageImportExport = Loadable({
  loader: () => import('./views/Admin/LanguageImportExport'),
  loading: Loading,
});

const UserStatusHistory = Loadable({
  loader: () => import('./views/AuditHistory/UserStatusHistory/UserStatusHistory'),
  loading: Loading,
});

const LoginAttemptsAudit = Loadable({
  loader: () => import('./views/AuditHistory/LoginAttemptsAudit/LoginAttemptsAudit'),
  loading: Loading,
});

const AdministrativeActivities = Loadable({
  loader: () => import('./views/AuditHistory/AdministrativeActivities/AdministrativeActivities'),
  loading: Loading,
});

const AuditHistory = Loadable({
  loader: () => import('./views/AuditHistory/AuditHistory/AuditHistory'),
  loading: Loading,
});

const BroadcastEmailMsg = Loadable({
  loader: () => import('./views/BCMAdmin/Communications/BroadcastEmailMsg'),
  loading: Loading,
});

const ReenableSuspendedAccounts = Loadable({
  loader: () => import('./views/Security/ReenableSuspendedAccounts/ReenableSuspendedAccounts'),
  loading: Loading,
});

const ViewSchedulerList = Loadable({
  loader: () => import('./views/TaskScheduler/ViewSchedulerList/ViewSchedulerList'),
  loading: Loading,
});

const ViewSchedulerInput = Loadable({
  loader: () => import('./views/TaskScheduler/ViewSchedulerInput/ViewSchedulerInput'),
  loading: Loading,
});

const LevelList = Loadable({
  loader: () => import('./views/BCMAdmin/ScorecardLevelList/ScorecardLevelList'),
  loading: Loading,
});

const AnnoucementSetup = Loadable({
  loader: () => import('./views/BCMAdmin/AnnoucementSetup/AnnoucementSetup'),
  loading: Loading,
});

const SetupUserAccessRightList = Loadable({
  loader: () => import('./views/BCMAdmin/SetupUserAccessRight/SetupUserAccessRightList'),
  loading: Loading,
});

const ProfileMaintenance = Loadable({
  loader: () => import('./views/BCMAdmin/ReportingFrequencySetup/ProfileMaintenance/ProfileMaintenance'),
  loading: Loading,
});

const ProfileMaintenanceInput = Loadable({
  loader: () => import('./views/BCMAdmin/ReportingFrequencySetup/ProfileMaintenanceInput/ProfileMaintenanceInput'),
  loading: Loading,
});

//const ProfileAccessSetupforSubAdmin = Loadable({
//  loader: () => import('./views/BCMAdmin/ReportingFrequencySetup/ProfileAccessSetupforSubAdmin/ProfileAccessSetup/ProfileAccessSetupforSubAdmin'),
//  loading: Loading,
//});

//const UpdateProfileAccessSetupforSubAdmin = Loadable({
//  loader: () => import('./views/BCMAdmin/ReportingFrequencySetup/ProfileAccessSetupforSubAdmin/UpdateProfileAccessSetupforSubAdmin/UpdateProfileAccessSetupforSubAdmin'),
//  loading: Loading,
//});

const AdminNonAvailabilityImpact = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ImpactOfNonAvailability/AdminNonAvailabilityImpact'),
  loading: Loading,
});

const SetupUserAccessRightDetails = Loadable({
  loader: () => import('./views/BCMAdmin/SetupUserAccessRight/SetupUserAccessRightDetails'),
  loading: Loading,
});

const Division = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/AlternateSiteSetup/Division/Division'),
  loading: Loading,
});

const FrequencySetup = Loadable({
  loader: () => import('./views/BCMAdmin/ReportingFrequencySetup/FrequencySetup/FrequencySetup'),
  loading: Loading,
});

const ScorecardDetails = Loadable({
  loader: () => import('./views/BCMAdmin/ScorecardDetails/ScorecardDetails'),
  loading: Loading,
});

const SetupMBCOList = Loadable({
  loader: () => import('./views/BCMAdmin/SetupMBCO/SetupMBCOList'),
  loading: Loading,
});

const SetupMBCODetails = Loadable({
  loader: () => import('./views/BCMAdmin/SetupMBCO/SetupMBCODetails'),
  loading: Loading,
});

const ITSystemListing = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ITSystemListing/ITSystemListing'),
  loading: Loading,
});

const ITSubSystemListing = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ITSubSystemListing/ITSubSystemListing'),
  loading: Loading,
});

const Production = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/AlternateSiteSetup/Production/Production'),
  loading: Loading,
});

const ProductionInput = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/AlternateSiteSetup/ProductionInput/ProductionInput'),
  loading: Loading,
});

const VitalRecord = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/VitalRecord/VitalRecord'),
  loading: Loading,
});

const RiskCategorySetup = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/RiskCategorySetup/RiskCategorySetup'),
  loading: Loading,
});

const RiskSubCategorySetup = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/RiskSubCategorySetup/RiskSubCategorySetup'),
  loading: Loading,
});
const EmergencyResponse = Loadable({
  loader: () => import('./views/BCMAdmin/EmergencyResponse/EmergencyResponse'),
  loading: Loading,
});

const CrisisManagementTeam = Loadable({
  loader: () => import('./views/BCMAdmin/CrisisManagementTeam/CrisisManagementTeam'),
  loading: Loading,
});
const BusinessFunctionFrequency = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/BusinessFunctionFrequency/BusinessFunctionFrequency'),
  loading: Loading,
});

const RolesAndResponsibilities = Loadable({
  loader: () => import('./views/BCMAdmin/RolesAndResponsibilities/RolesAndResponsibilities'),
  loading: Loading,
});



const EmergencyCommandCenter = Loadable({
  loader: () => import('./views/BCMAdmin/EmergencyCommandCenter/EmergencyCommandCenter'),
  loading: Loading,
});

const ResourceTypeandTimeHorizon = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ResourceType _TimeHorizon/Resource_Time/ResourceTime'),
  loading: Loading,
});

const BusinessFunctionImpactType = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/BusinessFunctionImpactType/ImpactType'),
  loading: Loading,
});

const CriticalitySetupList = Loadable({
  loader: () => import('./views/BCMAdmin/CriticalitySetup/CriticalitySetupList'),
  loading: Loading,
});

const ImpactRatingSetupList = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ImpactRatingSetup/ImpactRatingSetupList/ImpactRatingSetupList'),
  loading: Loading,
});

const ImpactRatingSetupInput = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ImpactRatingSetup/ImpactRatingSetupInput/ImpactRatingSetupInput'),
  loading: Loading,
});

const ImpactRatingColumnSetupList = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/ImpactRatingSetup/ImpactRatingColumnSetupList/ImpactRatingColumnSetupList'),
  loading: Loading,
});

const AdminLevel = Loadable({
  loader: () => import('./views/BCMAdmin/OrganisationStructureSetup/AdminLevel/AdminLevel'),
  loading: Loading,
});

const BCMUser_EmergencyCommandCenter = BCMUserLoad({
  loader: () => import('./views/BCMUser/EmergencyCommandCenter/EmergencyCommandCenter'),
  loading: Loading,
});

const BCMUser_EmergencyResponse = BCMUserLoad({
  loader: () => import('./views/BCMUser/EmergencyResponse/EmergencyResponse'),
  loading: Loading,
});

const InternalDependenciesList = BCMUserLoad({
  loader: () => import('./views/BCMUser/InternalDependencies/InternalDependenciesList'),
  loading: Loading,
});

const InternalDependenciesDetails = BCMUserLoad({
  loader: () => import('./views/BCMUser/InternalDependencies/InternalDependenciesDetails'),
  loading: Loading,
});

const ITApplicationsListing = BCMUserLoad({
  loader: () => import('./views//BCMUser/ITApplications/ITAppicationsListing/ITApplicationsListing'),
  loading: Loading,
});

const ITApplications = BCMUserLoad({
  loader: () => import('./views/BCMUser/ITApplications/ITApplicationsDetails/ITApplications'),
  loading: Loading,
});

const RiskScenarioList = BCMUserLoad({
  loader: () => import('./views/BCMUser/RiskScenario/RiskScenarioList'),
  loading: Loading,
});

const RiskScenarioInput = BCMUserLoad({
  loader: () => import('./views/BCMUser/RiskScenario/RiskScenarioInput'),
  loading: Loading,
});

const ExternalDependenciesList = BCMUserLoad({
  loader: () => import('./views/BCMUser/ExternalDependencies/ExternalDependenciesList'),
  loading: Loading,
});

const ExternalDependenciesDetails = BCMUserLoad({
  loader: () => import('./views/BCMUser/ExternalDependencies/ExternalDependenciesDetails'),
  loading: Loading,
});

const ScorecardMasterSelection = Loadable({
  loader: () => import('./views/BCMUser/ScorecardMasterSelection/ScorecardMasterSelection'),
  loading: Loading,
});

const StationNameSetup = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/BusinessFunctionStationSetup/StationSetup/StationSetup'),
  loading: Loading,
});

const StationNameSetupInput = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/BusinessFunctionStationSetup/StationSetupInput/StationSetupInput'),
  loading: Loading,
});

const BCMAuditLog = BCMUserLoad({
  loader: () => import('./views/BCMUser/BCMAuditLog'),
  loading: Loading,
});

const BCMUser_CrisisManagementTeam = BCMUserLoad({
  loader: () => import('./views/BCMUser/CrisisManagementTeam/CrisisManagementTeam'),
  loading: Loading,
});

const BCMUser_RolesAndResponsibilities = BCMUserLoad({
  loader: () => import('./views/BCMUser/RolesAndResponsibilities/RolesAndResponsibilities'),
  loading: Loading,
});

const RolesAndResponsibiliesDetails = Loadable({
  loader: () => import('./views/BCMUser/RolesAndResponsibilities/RolesAndResponsibilitiesDetails/RolesAndResponsibilitiesDetails'),
  loading: Loading,
})

const ReturnToNormalOperation = Loadable({
  loader: () => import('./views/BCMAdmin/ReturnToNormalOperation/ReturnToNormalOperation'),
  loading: Loading,
});
const ActionPlanInput = BCMUserLoad({
  loader: () => import('./views/BCMUser/RiskScenario/ActionPlanInput'),
  loading: Loading,
});
const ResourceRequirementList = BCMUserLoad({
  loader: () => import('./views/BCMUser/ResourceRequirement/ResourceRequirementList'),
  loading: Loading,
});

const DepartmentInfoList = BCMUserLoad({
  loader: () => import('./views/BCMUser/DepartmentInfo/DepartmentInfoList'),
  loading: Loading,
});

const DepartmentInfoDetails = BCMUserLoad({
  loader: () => import('./views/BCMUser/DepartmentInfo/DepartmentInfoDetails'),
  loading: Loading,
});

const MBCO = BCMUserLoad({
  loader: () => import('./views/BCMUser/MBCO/MBCO'),
  loading: Loading,
});

const cbf_VitalRecord = BCMUserLoad({
  loader: () => import('./views/BCMUser/CBFVitalRecord/cbf_VitalRecord'),
  loading: Loading,
});

const cbf_VitalRecordDetail = BCMUserLoad({
  loader: () => import('./views/BCMUser/CBFVitalRecord/VitalRecordDetail/cbf_VitalRecordDetail'),
  loading: Loading,
});


const BCMUser_ReturnToNormalOperationListing = BCMUserLoad({
  loader: () => import('./views/BCMUser/ReturnToNormalOperation/ReturnToNormalOperationListing/ReturnToNormalOperation'),
  loading: Loading,
});

const BCMUser_ReturnToNormalOperationDetails = BCMUserLoad({
  loader: () => import('./views/BCMUser/ReturnToNormalOperation/ReturnToNormalOperationDetails/ReturnToNormalOperationDetails'),
  loading: Loading,
});

const ManualWorkaroundList = BCMUserLoad({
  loader: () => import('./views/BCMUser/ManualWorkaround/ManualWorkaroundList'),
  loading: Loading,
});

const ManualWorkaroundDetails = BCMUserLoad({
  loader: () => import('./views/BCMUser/ManualWorkaround/ManualWorkaroundDetails'),
  loading: Loading,
});

const HistoryList = BCMUserLoad({
  loader: () => import('./views/BCMUser/HistoryList/HistoryList'),
  loading: Loading,
});

const Cbf = BCMUserLoad({
  loader: () => import('./views/BCMUser/BusinessImpactAnalysis/CbfInput/CBF'),
});

const CbfList = BCMUserLoad({
  loader: () => import('./views/BCMUser/BusinessImpactAnalysis/CbfList/CbfList'),
})

const SelectScorecardModal = Loadable({
  loader: () => import('./components/SelectScorecardModal/SelectScorecardModal'),
  loading: Loading,
})

const Stimulsoft_BCM_Profile = Loadable({
  loader: () => import('./views/StimulsoftDashboard/Stimulsoft_BCM_Profile/Stimulsoft_BCM_Profile'),
  loading: Loading,
});

const Stimulsoft_BCM_Progress = Loadable({
  loader: () => import('./views/StimulsoftDashboard/Stimulsoft_BCM_Progress/Stimulsoft_BCM_Progress'),
  loading: Loading,
});

const Stimulsoft_System_Dependencies = Loadable({
  loader: () => import('./views/StimulsoftDashboard/Stimulsoft_System_Dependencies/Stimulsoft_System_Dependencies'),
  loading: Loading,
});

const ReferenceRecords = BCMUserLoad({
  loader: () => import('./views/BCMUser/ReferenceRecords/ReferenceRecords'),
  loading: Loading,
});

const CbfInCharge = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/BusinessFunctionCbfInChargeSetup/CbfIncharge'),
  loading: Loading,
});

const SubmitForApproval = BCMUserLoad({
  loader: () => import('./views/BCMUser/SubmitForApproval/SubmitForApproval'),
  loading: Loading,
});

const FiscalYearMaintenance = Loadable({
  loader: () => import('./views/BCMAdmin/FiscalYearMaintenance/FiscalYearMaintenance'),
  loading: Loading,
});

const ExternalSocialSetupList = Loadable({
  loader: () => import('./views/Admin/ExternalSocialSetup/ExternalSocialSetupList'),
  loading: Loading,
});

const ExternalSocialSetupDetails = Loadable({
  loader: () => import('./views/Admin/ExternalSocialSetup/ExternalSocialSetupDetails'),
  loading: Loading,
});

const RecoveryActionType = Loadable({
  loader: () => import('./views/BCMAdmin/BCMSetup/RecoveryActionType/RecoveryActionType'),
  loading: Loading,
});


const BCMDashboard = Loadable({
  loader: () => import('./views/BCMDashboard'),
  loading: Loading,
});

const BCMProfile = Loadable({
  loader: () => import('./views/BCMDashboard/BCMProfile'),
  loading: Loading,
});

const SetupReportQueryType = Loadable({
  loader: () => import('./views/BCMAdmin/SetupReportQueryType'),
  loading: Loading,
});

const SetupReportQueryColumn = Loadable({
  loader: () => import('./views/BCMAdmin/SetupReportQueryColumn'),
  loading: Loading,
});

const AbbreviationSetup = Loadable({
  loader: () => import('./views/BCMAdmin/AbbreviationSetup'),
  loading: Loading,
});

const FAQ = Loadable({
  loader: () => import('./views/BCMFAQ/FAQ'),
  loading: Loading,
});

const FAQDetails = Loadable({
  loader: () => import('./views/BCMFAQ/FAQDetails/FAQDetails'),
  loading: Loading,
});

const FAQAdminList = Loadable({
  loader: () => import('./views/BCMFAQ/FAQAdminList/FAQAdminList'),
  loading: Loading,
});


const SetupUserWorkflowList = Loadable({
  loader: () => import('./views/BCMAdmin/SetupUserWorkflowRight/SetupUserWorkflowRightList/SetupUserWorkflowRightList'),
  loading: Loading,
});

const SetupUserWorkflowDetails = Loadable({
  loader: () => import('./views/BCMAdmin/SetupUserWorkflowRight/SetupUserWorkflowRightDetails/SetupUserWorkflowDetails'),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { moduleCode: '', screenCode: '', path: "/", exact: true, name: "Home", component: DefaultLayout },

  { moduleCode: '', screenCode: '', path: '/admin', exact: true, routeName: 'System Admin', name: 'System Admin', component: UserList },
  { moduleCode: '', screenCode: 'ADMFRM101', path: "/admin/user-management/user-list", name: "User List", component: UserList },
  { moduleCode: '', screenCode: 'ADMFRM101', path: "/admin/user-management/add-user", name: "User Management", component: UserInformation },
  { moduleCode: '', screenCode: 'ADMFRM101', path: "/admin/user-management/edit-user", name: "User Management", component: UserInformation },
  { moduleCode: '', screenCode: 'ADMFRM102', path: "/admin/sub-admin-access/view", name: "View", component: View },
  { moduleCode: '', screenCode: 'ADMFRM857', path: "/admin/setup-role/roles", name: "Roles", component: Roles },
  { moduleCode: '', screenCode: 'ADMFRM320', path: "/admin/licenseinfo", name: "License Info", component: LicenseInfo },
  { moduleCode: '', screenCode: 'ADMFRM452', path: "/admin/utilities/configure-system-settings", name: "Configure System Settings", component: ConfigureSystemSettings },
  { moduleCode: '', screenCode: 'ADMFRM630', path: "/admin/utilities/smtp-settings-email-notification", name: "SMTP Settings Email Notification", component: SMTPSettingsEmailNotification },
  { moduleCode: '', screenCode: 'ADMFRM604', path: "/admin/utilities/customise-email-templates", name: "Customise Email Templates", component: CustomiseEmailTemplates },
  { moduleCode: '', screenCode: 'ADMFRM111', path: "/admin/languageimportexport", name: "Language Import Export", component: LanguageImportExport },
  { moduleCode: '', screenCode: 'ADMFRM859', path: "/admin/utilities/logo-import", name: "Logo Import", component: LogoImport },
  { moduleCode: '', screenCode: 'ADMFRM118', path: "/admin/domainserver", name: "Domain Server", component: DomainServer },
  { moduleCode: '', screenCode: 'ADMFRM1139', path: "/admin/utilities/email-log", name: "Email Log", component: EmailLog },
  { moduleCode: '', screenCode: 'ADMFRM126', path: "/admin/utilities/unsent-email-log", name: "Unsent Email Log", component: UnsentEmailLog },
  { moduleCode: '', screenCode: 'ADMFRM127', path: "/admin/systemlog", name: "System Log", component: SystemLog },
  { moduleCode: '', screenCode: 'ADMFRM1138', path: "/admin/utilities/sent-email-log", name: "Sent Email Log", component: SendEmailLog },
  { moduleCode: '', screenCode: 'ADMFRM904', path: "/admin/externalsocialsetup/externalsocialsetuplist", name: "External Social Setup List", component: ExternalSocialSetupList },
  { moduleCode: '', screenCode: 'ADMFRM904', path: "/admin/externalsocialsetup/externalsocialsetupdetails", name: "External Social Setup Details", component: ExternalSocialSetupDetails },
  { moduleCode: '', screenCode: 'SECADM001', path: "/admin/security/security-setup-list", name: "Setup Security Settings", component: SecuritySetupList },
  { moduleCode: '', screenCode: 'SECADM001', path: "/admin/security/security-setup-input", name: "Setup Security Settings", component: SecuritySetupInput },
  { moduleCode: '', screenCode: 'SECADM002', path: "/admin/security/re-enable-suspended-accounts", name: "Re-enable Suspended Accounts", component: ReenableSuspendedAccounts },
  { moduleCode: '', screenCode: 'ADMFRM902', path: "/admin/task-scheduler/view-scheduler-history", name: "Setup Security Settings", component: ViewSchedulerHistory },
  { moduleCode: '', screenCode: 'ADMFRM903', path: "/admin/task-scheduler/view-scheduler-list", name: "View Scheduler List", component: ViewSchedulerList },
  { moduleCode: '', screenCode: 'ADMFRM903', path: "/admin/task-scheduler/view-scheduler-input", name: "View Scheduler Input", component: ViewSchedulerInput },
  { moduleCode: '', screenCode: 'ADMFRM903', path: "/admin/task-scheduler/view-scheduler-edit", name: "View Scheduler Input", component: ViewSchedulerInput },
  { moduleCode: '', screenCode: 'SECADM006', path: "/admin/audit-history/administrative-activities", name: "Administrative Activities", component: AdministrativeActivities },
  { moduleCode: '', screenCode: 'ADMFRM605', path: "/admin/audit-history/audit-history", name: "Audit History", component: AuditHistory },
  { moduleCode: '', screenCode: 'SECADM003', path: "/admin/audit-history/login-attempts-audit", name: "Login Attempts Audit", component: LoginAttemptsAudit },
  { moduleCode: '', screenCode: 'SECADM007', path: "/admin/audit-history/user-activity-log", name: "User Activity Log", component: UserActivityLog },
  { moduleCode: '', screenCode: 'SECADM004', path: "/admin/audit-history/user-status-history", name: "User Status History", component: UserStatusHistory },
  { moduleCode: '', screenCode: 'SECADM005', path: "/admin/audit-history/archive", name: "Archive", component: Archive },

  { moduleCode: '', screenCode: '', path: '/bcmadmin', exact: true, routeName: 'BCM Admin', name: 'BCM Admin', component: LevelList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM126', path: "/bcmadmin/organisation_structure_setup/admin_level", name: "Admin Level", component: AdminLevel },
  { moduleCode: 'BCM', screenCode: 'BCMFRM127', path: "/bcmadmin/scorecard-level-list", name: "Scorecard Level Listing", component: LevelList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM127', path: "/bcmadmin/setupscorecarddetails/", name: "Scorecard Details", component: ScorecardDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM128', path: "/bcmadmin/bcmsetup/altsitesetup/division", name: "Department Setup", component: Division },
  { moduleCode: 'BCM', screenCode: 'BCMFRM129', path: "/bcmadmin/bcmsetup/altsitesetup/production", name: "Sub Department/Main Site Setup", component: Production },
  { moduleCode: 'BCM', screenCode: 'BCMFRM129', path: "/bcmadmin/bcmsetup/altsitesetup/production-input", name: "Sub Department/Main Site Setup", component: ProductionInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM129', path: "/bcmadmin/production-input-edit/:id", name: "Production Edit", component: ProductionInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM130', path: "/bcmadmin/setupmbco/setupmbcolist", name: "Setup MBCO", component: SetupMBCOList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM130', path: "/bcmadmin/setupmbco/setupmbcodetails", name: "Setup MBCO Details", component: SetupMBCODetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM131', path: "/bcmadmin/criticalitysetup/criticalitysetuplist", name: "Criticality Setup", component: CriticalitySetupList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM132', path: "/bcmadmin/bcmsetup/business-function-frequency", name: "Business Function - Frequency", component: BusinessFunctionFrequency },
  { moduleCode: 'BCM', screenCode: 'BCMFRM133', path: "/bcmadmin/bcmsetup/impact-rating-setup-list", name: "Impact Rating Setup List", component: ImpactRatingSetupList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM133', path: "/bcmadmin/bcmsetup/impact-rating-setup-input", name: "Impact Rating Setup Input", component: ImpactRatingSetupInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM133', path: "/bcmadmin/bcmsetup/impact-rating-column-setup-list", name: "Impact Rating Column Setup List", component: ImpactRatingColumnSetupList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM134', path: "/bcmadmin/bcmsetup/business-function-impacttype", name: "Business Function Impact Type", component: BusinessFunctionImpactType },
  { moduleCode: 'BCM', screenCode: 'BCMFRM135', path: "/bcmadmin/bcmsetup/businessfunctionstationsetup/station-setup", name: "Business Function Station Setup", component: StationNameSetup },
  { moduleCode: 'BCM', screenCode: 'BCMFRM135', path: "/bcmadmin/bcmsetup/businessfunctionstationsetup/station-setup-input", name: "Business Function Station Setup Input", component: StationNameSetupInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM152', path: "/bcmadmin/bcmsetup/businessfunctioncbfInChargeSetup/cbfInCharge", name: "Business Function Who In Charge Setup", component: CbfInCharge },
  { moduleCode: 'BCM', screenCode: 'BCMFRM136', path: "/bcmadmin/bcmsetup/resourcetime", name: "Resource Type and Time Horizon", component: ResourceTypeandTimeHorizon },
  { moduleCode: 'BCM', screenCode: 'BCMFRM137', path: "/bcmadmin/bcmsetup/it-system-listing", name: "IT System Listing", component: ITSystemListing },
  { moduleCode: 'BCM', screenCode: 'BCMFRM138', path: "/bcmadmin/bcmsetup/it-sub-system-listing", name: "IT Sub System Listing", component: ITSubSystemListing },
  { moduleCode: 'BCM', screenCode: 'BCMFRM139', path: "/bcmadmin/bcmsetup/admin-non-availability-impact", name: "Dependencies - Impact of Non-Availability", component: AdminNonAvailabilityImpact },
  { moduleCode: 'BCM', screenCode: 'BCMFRM140', path: "/bcmadmin/bcmsetup/vital-record", name: "Vital Record", component: VitalRecord },
  { moduleCode: 'BCM', screenCode: 'BCMFRM141', path: "/bcmadmin/bcmsetup/risk-category-setup", name: "Risk Category Setup", component: RiskCategorySetup },
  { moduleCode: 'BCM', screenCode: 'BCMFRM142', path: "/bcmadmin/bcmsetup/risk-sub-category-setup", name: "Sub-Risk Category Setup", component: RiskSubCategorySetup },
  { moduleCode: 'BCM', screenCode: 'BCMFRM155', path: "/bcmadmin/bcmsetup/recoveryactiontype", name: "Recovery Action Type", component: RecoveryActionType },
  { moduleCode: 'BCM', screenCode: 'BCMFRM143', path: "/bcmadmin/emergencyresponse", name: "Emergency Response - Agencies", component: EmergencyResponse },
  { moduleCode: 'BCM', screenCode: 'BCMFRM144', path: "/bcmadmin/emergencycommandcenter", name: "Emergency Operation Center (EOC)", component: EmergencyCommandCenter },
  { moduleCode: 'BCM', screenCode: 'BCMFRM124', path: "/bcmadmin/crisis-management-team", name: "Crisis Management Team", component: CrisisManagementTeam },
  { moduleCode: 'BCM', screenCode: 'BCMFRM125', path: "/bcmadmin/roles-and-responsibilities", name: "Roles And Responsibilities", component: RolesAndResponsibilities },
  { moduleCode: 'BCM', screenCode: 'BCMFRM145', path: '/bcmadmin/return-to-normal-operation', name: 'Return To Normal Operation', component: ReturnToNormalOperation },
  { moduleCode: 'BCM', screenCode: 'BCMFRM146', path: "/bcmadmin/setupuseraccessright/setupuseraccessrightlist", name: "Setup User Access Right", component: SetupUserAccessRightList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM146', path: "/bcmadmin/setupuseraccessright/setupuseraccessrightdetails", name: "Setup User Access Right Details", component: SetupUserAccessRightDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM147', path: "/bcmadmin/broadcastemail", name: "BroadcastEmailMessage", component: BroadcastEmailMsg },
  { moduleCode: 'BCM', screenCode: 'BCMFRM148', path: "/bcmadmin/annoucementsetup", name: "Maintain Announcement Board Setup", component: AnnoucementSetup },
  { moduleCode: 'BCM', screenCode: 'BCMFRM149', path: "/bcmadmin/profile-maintenance", name: "Profile Maintenance", component: ProfileMaintenance },
  { moduleCode: 'BCM', screenCode: 'BCMFRM149', path: "/bcmadmin/profile-maintenance-input", name: "Profile Maintenance Input", component: ProfileMaintenanceInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM150', path: "/bcmadmin/frequency-setup", name: "Frequency Setup", component: FrequencySetup },
  //{ moduleCode: 'BCM', screenCode: 'BCMFRM151', path: "/bcmadmin/reporting-frequency-setup/profile-access-setup-for-subadmin", name: "Profile Access Setup for Sub Admin", component: ProfileAccessSetupforSubAdmin },
  //{ moduleCode: 'BCM', screenCode: 'BCMFRM151', path: "/bcmadmin/reporting-frequency-setup/update-profile", name: "Update Profile Access Setup for Sub Admin", component: UpdateProfileAccessSetupforSubAdmin },
  { moduleCode: 'BCM', screenCode: 'BCMFRM154', path: "/bcmadmin/fiscalyearmaintenance", name: "Fiscal Year Maintenance", component: FiscalYearMaintenance },
  { moduleCode: 'BCM', screenCode: 'BCMFRM178', path: "/bcmadmin/abbreviationsetup/", name: "Abbreviation Setup", component: AbbreviationSetup },
  { moduleCode: 'BCM', screenCode: 'BCMFRM156', path: "/bcmadmin/setupreportquerytype/", name: "Setup Report Query Type", component: SetupReportQueryType },
  { moduleCode: 'BCM', screenCode: 'BCMFRM157', path: "/bcmadmin/setupreportquerycolumn/", name: "Setup Report Query Column", component: SetupReportQueryColumn },
  { moduleCode: 'BCM', screenCode: 'BCMFRM184', path: "/bcmadmin/setup-user-workflow-right", name: "Setup User Workflow Right", component: SetupUserWorkflowList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM185', path: "/bcmadmin/setup-user-workflow-right-details", name: "Setup User Workflow Right Details", component: SetupUserWorkflowDetails },

  { moduleCode: '', screenCode: '', path: '/bcmuser', exact: true, routeName: 'BCM User', name: 'BCM User', component: ScorecardMasterSelection },
  { moduleCode: 'BCM', screenCode: 'BCMFRM158', path: "/bcmuser/scorecard-selection", name: "Scorecard Selection", component: SelectScorecardModal },
  { moduleCode: 'BCM', screenCode: 'BCMFRM158', path: '/bcmuser/scorecardmasterselection', name: 'Response Plan Master Selection', component: ScorecardMasterSelection },
  { moduleCode: 'BCM', screenCode: 'BCMFRM159', path: "/bcmuser/departmentinfo/departmentinfolist", name: "Department Info List", component: DepartmentInfoList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM159', path: "/bcmuser/departmentinfo/departmentinfodetails", name: "Department Info Details", component: DepartmentInfoDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM160', path: "/bcmuser/mbco", name: "Minimum Business Continuity Objective", component: MBCO },
  { moduleCode: 'BCM', screenCode: 'BCMFRM161', path: "/bcmuser/businessimpactanalysis/CBFList", name: "Business Impact Analysis", component: CbfList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM161', path: "/bcmuser/businessimpactanalysis/CBF", name: "Business Impact Analysis", component: Cbf },
  { moduleCode: 'BCM', screenCode: 'BCMFRM162', path: "/bcmuser/itapplicationlisting", name: "IT Applications Listing", component: ITApplicationsListing },
  { moduleCode: 'BCM', screenCode: 'BCMFRM162', path: "/bcmuser/it-applications", name: "IT Applications", component: ITApplications },
  { moduleCode: 'BCM', screenCode: 'BCMFRM163', path: "/bcmuser/internaldependencies/internaldependencieslist", name: "Internal Dependencies List", component: InternalDependenciesList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM163', path: "/bcmuser/internaldependencies/internaldependenciesdetails", name: "Internal Dependencies Details", component: InternalDependenciesDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM164', path: "/bcmuser/externaldependencies/externaldependencieslist", name: "External Dependencies List", component: ExternalDependenciesList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM164', path: "/bcmuser/externaldependencies/externaldependenciesdetails", name: "External Dependencies Details", component: ExternalDependenciesDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM165', path: '/bcmuser/cbf-vital-record', name: 'Vital Record', component: cbf_VitalRecord },
  { moduleCode: 'BCM', screenCode: 'BCMFRM181', path: '/bcmuser/cbf-vital-record-detail', name: 'Vital Record', component: cbf_VitalRecordDetail },
  { moduleCode: 'BCM', screenCode: 'BCMFRM166', path: '/bcmuser/manual-workaround-list', name: 'Manual Workaround', component: ManualWorkaroundList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM166', path: '/bcmuser/manual-workaround-details', name: 'Manual Workaround', component: ManualWorkaroundDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM167', path: '/bcmuser/emergencyresponse', name: 'Emergency Response', component: BCMUser_EmergencyResponse },
  { moduleCode: 'BCM', screenCode: 'BCMFRM168', path: '/bcmuser/emergencycommandcenter', name: 'Emergency Operation Center (EOC)', component: BCMUser_EmergencyCommandCenter },
  { moduleCode: 'BCM', screenCode: 'BCMFRM169', path: '/bcmuser/crisis-management-team', name: 'Crisis Management Team', component: BCMUser_CrisisManagementTeam },
  { moduleCode: 'BCM', screenCode: 'BCMFRM170', path: "/bcmuser/resourcerequirement/resourcerequirementlist", name: "Resource Requirement List", component: ResourceRequirementList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM171', path: '/bcmuser/riskscenario/riskscenariolist', name: 'Risk Scenario List', component: RiskScenarioList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM171', path: '/bcmuser/riskscenario/riskscenarioinput', name: 'Risk Scenario Input', component: RiskScenarioInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM171', path: '/bcmuser/riskscenario/actionplaninput', name: 'Action Plan Input', component: ActionPlanInput },
  { moduleCode: 'BCM', screenCode: 'BCMFRM172', path: '/bcmuser/roles-and-responsibilities', name: 'Roles And Responsibilities', component: BCMUser_RolesAndResponsibilities },
  { moduleCode: 'BCM', screenCode: 'BCMFRM181', path: '/bcmuser/roles-and-responsibilities-detials', name: 'Roles And Responsibilities', component: RolesAndResponsibiliesDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM173', path: '/bcmuser/return-to-normal-operation', name: 'Return To Normal Operation', component: BCMUser_ReturnToNormalOperationListing },
  { moduleCode: 'BCM', screenCode: 'BCMFRM183', path: '/bcmuser/return-to-normal-operation-Details', name: 'Return To Normal Operation Details', component: BCMUser_ReturnToNormalOperationDetails },
  { moduleCode: 'BCM', screenCode: 'BCMFRM174', path: '/bcmuser/reference-records', name: 'Reference Records', component: ReferenceRecords },
  { moduleCode: 'BCM', screenCode: 'BCMFRM175', path: "/bcmuser/bcmauditlog", name: "Audit Log", component: BCMAuditLog },
  { moduleCode: 'BCM', screenCode: 'BCMFRM176', path: "/bcmuser/historylist", name: "History List", component: HistoryList },
  { moduleCode: 'BCM', screenCode: 'BCMFRM177', path: "/bcmuser/submitforapproval", name: "Submit For Approval", component: SubmitForApproval },


  { moduleCode: 'BCM', screenCode: '', path: '/bcmreport', exact: true, routeName: 'BCM Report', name: 'BCM Report', component: MainReport },
  { moduleCode: 'BCM', screenCode: '', path: "/bcmreport/report/mainReport", name: "MainReport", component: MainReport },
  { moduleCode: 'BCM', screenCode: '', path: "/bcmreport/report/viewReport", name: "ViewReport", component: ViewReport },
  { moduleCode: 'BCM', screenCode: '', path: "/bcmreport/report/customizeReport", name: "CustomizeReport", component: CustomizeReport },
  { moduleCode: 'BCM', screenCode: '', path: "/bcmreport/reportQuery/reportQuery", name: "ReportQuery", component: ReportQuery },

  { moduleCode: 'BCM', screenCode: '', path: '/bcmdashboard', exact: true, routeName: 'BCM Dashboard', name: 'BCM Dashboard', component: BCMDashboard },
  { moduleCode: 'BCM', screenCode: '', path: "/bcmdashboard/bcmprofile", name: "BCM Profile", component: BCMProfile },
  { moduleCode: 'BCM', screenCode: '', path: "/bcmdashboard", name: "BCM Dashboard", component: BCMDashboard },

  { moduleCode: '', screenCode: '', path: "/dashboard", name: "My Tasks", component: Dashboard },
  { moduleCode: '', screenCode: '', path: "/mytask", name: "MyTask", component: MyTask },

  { moduleCode: '', screenCode: '', path: "/annoucement/detailAnnoucement", name: "Detail Annoucement", component: DetailAnnoucement },
  { moduleCode: '', screenCode: '', path: "/stimulsoft_bcm_profile", name: "BCM Profile", component: Stimulsoft_BCM_Profile },
  { moduleCode: '', screenCode: '', path: "/stimulsoft_bcm_progress", name: "BCM Progress", component: Stimulsoft_BCM_Progress },
  { moduleCode: '', screenCode: '', path: "/stimulsoft_system_dependencies", name: "BCM System Dependencies", component: Stimulsoft_System_Dependencies },

  { moduleCode: '', screenCode: '', path: "/BCMFAQ/FAQ", name: "FAQ User", component: FAQ },
  { moduleCode: '', screenCode: '', path: "/BCMFAQ/FAQ-Details", name: "FAQ Details", component: FAQDetails },
  { moduleCode: '', screenCode: '', path: "/BCMFAQ/FAQAdminList", name: "FAQ Admin List", component: FAQAdminList }


];

export default routes;
